import { styled, AccordionSummary } from '@mui/material';

export const CustomAccordionSummary = styled(AccordionSummary)(() => ({
	'&&': {
		padding: 0,
	},
}));
